module.exports = __webpack_public_path__ + "static/media/b681571f-aab2-4935-a99c-6ee1063ce638.fe13f1d7.woff";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/b681571f-aab2-4935-a99c-6ee1063ce638.woff
// module id = 85
// module chunks = 0